module.exports = __webpack_public_path__ + "static/media/plantilla-migraciones-clientes.280e0cee.xlsx";